/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import moment from 'moment';
import utils from '../../../../lib/utils';
import Loading from '../../../common/Loading';
import './index.scss';

Modal.setAppElement('#root');

class Layover extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      name: '',
      error: false,
      errorMessage: 'Please enter valid phone number',
      list: [],
    };
  }
  checkforMatch(listnumber, input) {
    if (
      listnumber.replace('+1', '').replace(/\D/g, '') ===
      input.replace('+1', '').replace(/\D/g, '')
    ) {
      return true;
    } else {
      return false;
    }
  }
  componentDidMount() {
    // const { phone} = this.props;
    // let error = false;
    // let errorMessage ='Please enter valid phone number';
    // if(this.props.errorData.blockedNumbers &&
    //   this.props.errorData.blockedNumbers.length>0&&
    //   this.props.errorData.blockedNumbers.filter(block=> {
    //     return this.checkforMatch(block.phone,phone);
    //   }).length>0
    // ){
    //   error = true;
    //   errorMessage = 'This number is already blocked';
    // }
    // this.setState({
    //    phone:phone,
    //    error:error,
    //    errorMessage:errorMessage
    // })
    const { getOptOutnumbers, business, selectedLocation } = this.props;
    const { auth } = this.props;
    const { studio_id } = auth;
    const bzid = this.props.business.id||studio_id;
    const businessId = (selectedLocation && selectedLocation.studioId)? selectedLocation.studioId:bzid;
    const businessStatus = utils.getCookie('subscription_status');
    if (businessId && businessStatus==='LIVE') {
      getOptOutnumbers(businessId);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.errorData.errorReportSucess &&
      !nextProps.errorData.postErrorReport
    ) {
      if (nextProps.errorData.errorReport.status === 'success') {
        // this.closeModal()
      } else {
        this.setState({
          error: true,
          errorMessage: nextProps.errorData.errorReport.message,
        });
      }
    }
    if (nextProps.errorData.getBlockedNUmber === undefined) {
      //this.props.getBlockUser(nextProps.business.id)
    } else if (nextProps.errorData.blockedNumbers) {
      this.setState({
        list: nextProps.errorData.blockedNumbers,
      });
    }
    if (
      !nextProps.errorData.getBlockedNUmber &&
      nextProps.errorData.blockedNumberSuccess
    ) {
      this.setState({
        list: nextProps.errorData.blockedNumbers,
      });
    }
  }
  closeModal() {
    this.props.setblockOverlayVisibility(false);
    this.props.clearReportFlags();
    this.setState({
      phone: '',
      error: false,
    });
  }

  downloadReport = () => {
    const { getOptOutReport, business, selectedLocation , auth} = this.props;
    const { studio_id } = auth;
    const bzid = this.props.business.id||studio_id;
    const businessId = (selectedLocation && selectedLocation.studioId)? selectedLocation.studioId:bzid;
    if (businessId) {
      let filename = `TrueLark-${
        business.info.BUSINESS_NAME
      }-Optout_reports-${moment().format('YYYY-MM-DD:HH:mm:ss')}.csv`;
      getOptOutReport(businessId, filename);
    }
  };
  render() {
    const { modelopen, errorData } = this.props;
    const { error, errorMessage } = this.state;
    const { optoutnumbers } = errorData;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="overlay-top"
          contentLabel="Example Modal"
        >
          <div>
            {!errorData.errorReportSucess && (
              <div>
                <div className="modal-header">
                  <div className="title">Opted-out numbers</div>
                  <button className="modal-close" onClick={this.closeModal}>
                    X
                  </button>
                  <div className="sub-title">
                    Guests who have indicated they would like to be opted out of
                    SMS communication. Download report to view more details and
                    a full list.
                  </div>
                </div>
                <div className="optout-list">
                  <div className="title">
                    Recently opted-out (last 30 days):
                  </div>
                  {errorData.getOptoutnumbers ? (
                    <div className="conversation_loader">
                      <Loading />
                    </div>
                  ) : (
                    <>
                      {optoutnumbers &&
                      optoutnumbers.recent_n_details &&
                      optoutnumbers.recent_n_details.length > 0 ? (
                        <div className="content">
                          {optoutnumbers.recent_n_details.map((data, index) => {
                            return (
                              <div Key={index} className="phone-number">
                                <div className="data">
                                  <div className="name">{data.name}</div>
                                  <div className="date">
                                    {moment(data.optout_date_time.time).format(
                                      'MMM DD, YYYY',
                                    )}
                                  </div>
                                </div>
                                <div className="number">
                                  {utils.formatPhoneNumber(data.phone_number)}
                                </div>
                              </div>
                            );
                          })}
                          {optoutnumbers &&
                            optoutnumbers.unsubscribe_count > 0 && (
                              <div className="download-link">
                                <span
                                  className="button"
                                  onClick={this.downloadReport}
                                >
                                  Download report
                                </span>
                                to view all{' '}
                                <span className="count">
                                  ({optoutnumbers.unsubscribe_count} total)
                                </span>
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className="content">
                          <div className="empty-list">
                            You have no opted-out numbers
                          </div>
                          {optoutnumbers &&
                            optoutnumbers.unsubscribe_count > 0 && (
                              <div className="download-link">
                                <span
                                  className="button"
                                  onClick={this.downloadReport}
                                >
                                  Download report
                                </span>
                                to view all{' '}
                                <span className="count">
                                  ({optoutnumbers.unsubscribe_count} total)
                                </span>
                              </div>
                            )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default Layover;
